import { createApi } from '@bunker/shared/api';

export type { GlobalSearchHit } from '@bunker/shared/api';

/**
 * Bunker API facade for the web app.
 *
 * The implementation now lives in `@bunker/shared/api` (the same client the
 * React Native app uses) — here we just configure it for the browser: cookie
 * auth (`withCredentials`) and same-origin relative paths (`baseUrl` empty).
 * Method names are flat and unchanged, so every existing `api.*` call site
 * keeps working without edits.
 */
export const api = createApi({ withCredentials: true });
